import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function RouteProgress() {
  const [active, setActive] = useState(false);
  const timer = useRef<number | undefined>(undefined);
  const navType = useNavigationType();
  const loc = useLocation();

  useEffect(() => {
    setActive(true);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setActive(false), 400);
    return () => window.clearTimeout(timer.current);
  }, [navType, loc]);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: 2,
        width: active ? '100%' : 0,
        transition: 'width 0.4s ease',
        zIndex: 1000,
        background: 'var(--ant-color-primary)',
      }}
    />
  );
}
